/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ClientsRequestBuilderNavigationMetadata } from './clients/index.js';
/**
 * Uri template for the request builder.
 */
export const WithRealmNameItemRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithRealmNameItemRequestBuilderNavigationMetadata = {
    clients: {
        navigationMetadata: ClientsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map